export const mutations = {
  setViews(state, payload) {
    state.views = payload;
  },
  setSelectedView(state, payload) {
    state.selectedView = payload;
  },
  setSelectedViewId(state, payload) {
    state.selectedViewId = payload;
  },
  setActiveTagName(state, payload) {
    state.activeTagName = payload;
  },
};
